<template>
  <div class="source-options">
    <transition name="fade" mode="out-in">
      <div v-if="!visible" key="btns">
        <div class="source-options__row">
          <button v-if="!accessRules.created" class="source-options__link" :disabled="loading" @click.prevent="$emit('create-users-spreadsheet')">
            <i class="source-options__link-icon icon-edit-google-sheet"></i>
            CREATE USERS SHEET
          </button>
          <a v-else :href="accessRules.spreadsheetUrl" target="_blank" class="source-options__link">
            <i class="source-options__link-icon icon-edit-google-sheet"></i>
            EDIT USERS SHEET
          </a>
          <button
            v-if="accessRules.created"
            class="source-options__button"
            :disabled="loading"
            title="Refresh Users Sheet data"
            @click.prevent="$emit('refresh-users-spreadsheet')"
          >
            <i v-if="!refreshingSheetData" class="icon-refresh-arrow"></i>
            <div v-else class="icon-loader"></div>
          </button>
        </div>
        <GoogleFilePicker
          class="source-options__change-btn"
          :disabled="loading"
          :buttonText="!accessRules.created ? 'Add existing sheet' : 'Change source sheet'"
          @on-link-chosen="
            (val) => {
              $emit('update-spread-sheet-url', val)
              $emit('connect-users-spreadsheet', val)
            }
          "
        />
      </div>
    </transition>
    <div class="side-form__item" style="margin-top: 30px">
      <a
        class="sorting-constructor__link"
        target="_blank"
        href="https://help.spreadsimple.com/en/article/how-to-set-up-website-access-rules-1vre7ri/"
      >
        Help: How to set up website access rules?
      </a>
    </div>
  </div>
</template>

<script>
// import FormField from '@/components/form-field'
import { mapState } from 'vuex'
import GoogleFilePicker from '@/components/google-file-picker/GoogleFilePicker.vue'

export default {
  name: 'AccessManagementSpreadForm',
  components: {
    // FormField
    GoogleFilePicker
  },
  props: {
    v: {
      type: Object
    },
    btnsDisabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    refreshingSheetData: {
      type: Boolean,
      default: false
    },
    accessRulesError: {
      type: [String, null],
      default: null
    },
    accessRules: {
      type: Object
    }
  },
  data() {
    return {
      visible: false,
      url: ''
    }
  },
  computed: {
    ...mapState('app', ['websiteAccess'])
  },
  watch: {
    'accessRules.created'(val) {
      if (!val) {
        this.url = ''
      }
    },
    'accessRules.spreadsheetUrl'(val, oldVal) {
      this.url = this.accessRules.spreadsheetUrl
    }
  },
  created() {
    this.url = this.accessRules.spreadsheetUrl
  }
}
</script>
